import { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { postJson } from '../utils/shopApi';

const REASONS = [
  { key: 'NOT_AS_DESCRIBED', label: 'It is not as described' },
  { key: 'COUNTERFEIT', label: 'It looks like a fake or a copy' },
  { key: 'PROHIBITED', label: 'It should not be sold (illegal or unsafe)' },
  { key: 'WRONG_PRICE', label: 'The price is wrong or misleading' },
  { key: 'OTHER', label: 'Something else' },
];

/** A buyer's report about a product on a store's page or on the products page of ibigdo.com/shop. Someone at iBigDo looks at it; nothing is taken off by a report alone. */
export default function ReportProductModal({ slug, productId, productName, onClose }) {
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState(''); // a hidden field only a script fills in
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    if (!reason) { setError('Choose what is wrong with it.'); return; }
    setBusy(true);
    setError('');
    try {
      await postJson(`/api/public/shops/${encodeURIComponent(slug)}/products/${productId}/report`, { reason, details, email, website });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Your report could not be sent.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered data-testid="report-product">
      <Form onSubmit={send}>
        <Modal.Header closeButton><Modal.Title className="h5">Report this product</Modal.Title></Modal.Header>
        <Modal.Body>
          {done ? (
            <Alert variant="success" className="mb-0">Thank you. We will look at it. It is not taken off by a report alone: someone checks first.</Alert>
          ) : (
            <>
              <p className="text-muted small">{productName}</p>
              <Form.Group className="mb-3" controlId="report-reason">
                <Form.Label>What is wrong?</Form.Label>
                <Form.Select value={reason} onChange={(e) => setReason(e.target.value)} data-testid="report-reason">
                  <option value="">Choose...</option>
                  {REASONS.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3" controlId="report-details">
                <Form.Label>Tell us more (optional)</Form.Label>
                <Form.Control as="textarea" rows={3} maxLength={1000} value={details} onChange={(e) => setDetails(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-1" controlId="report-email">
                <Form.Label>Your email, if you want us to be able to write back (optional)</Form.Label>
                <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={200} autoComplete="email" />
              </Form.Group>
              <div style={{ position: 'absolute', left: '-9999px' }} aria-hidden="true">
                <label>Website<input tabIndex={-1} autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} /></label>
              </div>
              {error && <Alert variant="danger" className="mt-3 mb-0 py-2" data-testid="report-error">{error}</Alert>}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {done ? <Button onClick={onClose}>Close</Button> : (
            <>
              <Button variant="link" onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="primary" disabled={busy} data-testid="report-send">{busy ? 'Sending...' : 'Send report'}</Button>
            </>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
